import { IconButton, ITask, Actions, styled } from "@twilio/flex-ui";
import { useState } from "react";
import ExceptionLogger from "../../../../../ExceptionHelper";

const IconContainer = styled.div`
  margin: auto;
  padding-right: 0.8em;
`;
interface ParkChatButtonProps {
  task: ITask;
}

const ParkChatButton = ({ task }: ParkChatButtonProps) => {

  const [isClicked, setIsClicked] = useState(false);

  const onParkChat = () => {
    try{
      setIsClicked(true);
      Actions.invokeAction("ParkChat", { task });
    }
    catch(err){
      ExceptionLogger(err, "onParkChat", "ParkChatButton.tsx", "","");
    }
  };

  return (
    <IconContainer>
      <IconButton
        icon="HoldLarge"
        key="worker-directory-open"
        onClick={onParkChat}
        variant="secondary"
        title="Park Chat"
        disabled={isClicked}
      />
    </IconContainer>
  );
};

export default ParkChatButton;
